import React, { useEffect } from "react";
import "./Footer.css";
import { Form, InputGroup, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";

import { AllBranches, AllSocialLinks } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const branches = useSelector((state) => state?.common?.all_branches);
  const social_links = useSelector((state) => state?.common?.all_social_links);

  useEffect(() => {
    dispatch(AllBranches());
    dispatch(AllSocialLinks());
  }, [dispatch]);

  const handleNavClick = (path, e) => {
    e.preventDefault();

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "auto" });
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      }, 200);
    }
  };

  return (
    <>
      <footer className="Footer">
        <div className="container">
          <div className="row ">
            {/* Logo */}

            <div className="col-lg-4  col-sm-12 mb-4">
              <Link to={"/"}>
                <div className="logo_holder">
                  <img
                    src="/assets/images/home/footer/Final_Logo.png"
                    alt="Logo"
                    className="logo_img"
                  />
                </div>
              </Link>
              <div className="logo_text_holder">
                <p className="logo_text">
                  We help working professionals upskill with structured,
                  job-focused courses designed for real career growth.
                </p>
              </div>


              <div className="icon_links">
                {social_links?.map((item) => (
                  <a
                    key={item.id}
                    href={item.url}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${IDS.IMG_URL}${item.icon}`}
                      alt={item.name}
                      className="footer_icon"
                    />
                  </a>
                ))}
              </div>

              <br></br>

              <h5 className="footer_section_title">Download Our App</h5>
              <p className="footer_link">Learn on the go with the PST IT Solutions Mobile App.</p>
              <Link target="_blank" to={'https://play.google.com/store/apps/details?id=co.khal.mwkiq&pcampaignid=web_share'}>
                <img className="playstore" src={process.env.PUBLIC_URL + '/assets/images/home/footer/play-store.png'} />
              </Link>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-4 col-sm-6 col-12 mb-4 col_div">
              <h5 className="footer_section_title">Explore</h5>
              <div className="footer_links quick_links">
                {[
                  { label: "Home", path: "/" },
                  { label: "About Us", path: "/pst-it-solutions" },
                  { label: "Contact Us", path: "/contact-us" },
                  { label: "Terms & Conditions", path: "/terms-conditions" },
                  { label: "Privacy Policy", path: "/privacy-policy" },
                  { label: "Blogs", path: "/blogs" },
                ].map((item) => (
                  <NavLink
                    key={item.path}
                    as={Link}
                    to={item.path}
                    onClick={(e) => handleNavClick(item.path, e)}
                    className={`footer_link ${item.path === "/"
                      ? location.pathname === "/"
                        ? "active_footer_link"
                        : ""
                      : location.pathname.startsWith(item.path)
                        ? "active_footer_link"
                        : ""
                      }`}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </div>




            {branches?.map((branch) => (
              <div key={branch.id} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4 col_div">
                <h5 className="footer_section_title">{branch.name}</h5>
                <div className="footer_links">
                  <p className="footer_link">{branch.address}</p>
                  <p className="footer_link">
                    {branch.city?.name}, {branch.state?.name}
                  </p>

                  <div className="contact_holder">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: "#093D5D" }}
                      className="contact_icon"
                    />
                    <span className="footer_link">{branch.email}</span>
                  </div>

                  <div className="contact_holder">
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: "#093D5D" }}
                      className="contact_icon"
                    />
                    <span className="footer_link">{branch.mobile_no}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>



        {/* Footer Bottom */}
        <div className="container">
          <div className="footer_text_div">
            <p className="footer_text">
              ©2026 PST All Rights Reserved. Developed by
              <a
                href="https://profcymaglobal.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="link_text"
              >
                {" "}
                Profcyma Solutions Pvt Ltd
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
